import React, { useCallback, useEffect, useState } from "react";
import ContentHeading from "../../../components/layout/content/ContentHeading";
import moment from "moment";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import {
  FiberManualRecord,
  RemoveRedEyeOutlined,
  BorderColorOutlined,
} from "@mui/icons-material";
import CustomStatus from "../../../components/chip/CustomStatus";
import { ButtonPrimary } from "../../../components/button/ButtonCustoms";
import ModalSetting from "./components/modal/ModalSetting";
import { settingLeavePeriodApi } from "../../../api/setting-leave-period/setting-leave-period.api";
import { MenuItem, useMediaQuery, useTheme } from "@mui/material";
import StateComponents from "../../../components/state-component/StateComponents";
import { RootState } from "../../../store/store";
import { checkPermission } from "../../../utils/app.utils";
import { dateToView } from "../../../utils/date.utils";

type Props = {};

const SettingLeaveDay: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const profileReducer = useSelector((state: RootState) => state.profile.profile);
  const permission: any[] = profileReducer?.permission || [];
  const checkPermit = checkPermission('SettingLeaveDay', permission);

  const [dataSettingLeaveDay, setDataSettingLeaveDay] = useState<any[]>([]);
  const [start_date, set_start_date] = useState<string>("");
  const [end_date, set_end_date] = useState<string>("");
  const [filter_year, set_filter_year] = useState<any[]>([]);

  // const [year, setYear] = useState<any>([]);
  const [inputValueSearch, setInputValueSearch] = useState({
    year: "",
    period_date: [],
  });

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(
    dataSettingLeaveDay.length
  );
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const [isShowModalSetting, setIsShowModalSetting] = useState<boolean>(false);
  const [isShowModalSettingEdit, setIsShowModalSettingEdit] =
    useState<boolean>(false);
  const [modalData, setModalData] = useState({
    id_leave_period: 0,
    passing_year: false,
    year: "",
    start_date: "",
    end_date: "",
  });

  const handleColorStatus = (status_type: string) => {
    if (status_type === "active") {
      return "success";
    } else if (status_type === "pending") {
      return "warning";
    } else if (status_type === "inactive") {
      return "error";
    } else {
      return "error";
    }
  };
  const handleTextStatus = (status_type: string) => {
    if (status_type === "active") {
      return "อยู่ระหว่างใช้งาน";
    } else if (status_type === "pending") {
      return "ยังไม่ถึงเวลาใช้งาน";
    } else if (status_type === "inactive") {
      return "ปิดใช้งาน";
    } else {
      return "";
    }
  };

  const headCells = [
    {
      id: "#",
      width: 2,
      sortable: false,
      disablePadding: false,
      align: "center",
      label: "#",
    },
    {
      id: "year",
      width: 5,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "รอบปีงบประมาณ",
    },
    {
      id: "start_date",
      disablePadding: false,
      width: 15,
      sortable: false,
      align: "center",
      label: "วันที่เริ่มต้น",
    },
    {
      id: "end_date",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "วันที่สิ้นสุด",
    },
    {
      id: "user_updated",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "ผู้สร้าง/ปรับปรุงล่าสุด",
    },
    {
      id: "last_updated",
      disablePadding: false,
      align: "center",
      width: 50,
      label: "วันที่สร้าง/ปรับปรุงล่าสุด",
    },
    {
      id: "status",
      disablePadding: false,
      align: "center",
      width: 50,
      label: "สถานะ",
    },
    {
      id: "action",
      disablePadding: false,
      class: matches,
      align: "center",
      width: 50,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_leave_period,
      year,
      start_date,
      end_date,
      user_update,
      last_update,
      status,
      passing_year,
    } = objData;

    const objRenderData = {
      key: id_leave_period,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: no || "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: year,
        },
        {
          option: "TEXT",
          align: "center",
          label: start_date ? moment(start_date).format("DD/MM/YYYY") : "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: end_date ? moment(end_date).format("DD/MM/YYYY") : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: user_update,
        },
        {
          option: "TEXT",
          align: "center",
          label: last_update
            ? moment(last_update).format("YYYY-MM-DD HH:ss")
            : "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <CustomStatus
              label={handleTextStatus(status)}
              type="outlined"
              color={handleColorStatus(status)}
              icon={<FiberManualRecord />}
              width="150px"
            />
          ),
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches,
          component: (
            <>
              {checkPermit.isUpdate && (
                <BorderColorOutlined
                  onClick={() => {
                    setIsShowModalSettingEdit(true);
                    setModalData({
                      id_leave_period: id_leave_period,
                      passing_year: passing_year,
                      year: year,
                      start_date: start_date,
                      end_date: end_date,
                    });
                  }}
                  style={{
                    cursor: "pointer",
                    marginRight: 12,
                  }}
                />
              )}
              {checkPermit.isView && (
                <RemoveRedEyeOutlined
                  onClick={() => {
                    navigate(
                      routeName.cms.SettingLeaveDay + `/${id_leave_period}/detail`
                    );
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                />
              )}

            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const handleChangeValueSearch = (name: string, value: any) => {
    setInputValueSearch((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const getLeavePeroid = useCallback(async () => {
    let query: {
      page: number,
      limit: number,
      sortBy: string,
      sortType: string,
      leave_period?: number,
      leave_period_start?: string;
      leave_period_end?: string;
    } = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
    };
    if (inputValueSearch.year) query.leave_period = +inputValueSearch.year;
    if (start_date) query.leave_period_start = moment(start_date).format("YYYY-MM-DD");
    if (end_date) query.leave_period_end = moment(end_date).format("YYYY-MM-DD");
    const res = await settingLeavePeriodApi.getAllLeavePeriod(query);
    const data = res.data;
    if (data.status < 300 && data.data && data.data.items.length > 0) {
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
      const newData = data.data.items.map((item: any) => {
        return {
          id_leave_period: item.id_leave_period,
          year: item.leave_period,
          start_date: item.leave_period_start,
          end_date: item.leave_period_end,
          passing_year: item.passing_year,
          user_update: item?.modified ? (item?.modified
            ? item?.modified?.title +
            " " +
            item?.modified?.first_name +
            " " +
            item?.modified?.last_name
            : "-") : item?.created ? `${item?.created?.title || ""} ${item?.created?.first_name || ""} ${item?.created?.last_name || ""}` : "-",
          last_update: item.modified_date,
          status: item.status,
        };
      });
      setDataSettingLeaveDay(newData);
    } else {
      setDataSettingLeaveDay([]);
    }
  }, [page, pageLimit, sortBy, sortType, start_date, end_date, inputValueSearch.year])


  const handleGetDropdownYear = async () => {
    await settingLeavePeriodApi.dropdownYear().then((res) => {
      if (res.status < 300) {
        const data = res.data?.data || [];
        set_filter_year(data || []);
      }
    }).catch((err) => {
      console.log(err)
    })
  }

  useEffect(() => {
    getLeavePeroid();
  }, [getLeavePeroid]);

  useEffect(() => {
    handleGetDropdownYear();
  }, [])
  // useEffect(() => {
  //   setYear(generateYearRange(2565, 5));
  // }, []);

  return (
    <div>
      <ModalSetting
        setIsOpenModal={(isOpen: boolean) => setIsShowModalSetting(isOpen)}
        isOpenModal={isShowModalSetting}
        actionType="create"
        onFetch={() => {
          getLeavePeroid();
        }}
      />

      <ModalSetting
        setIsOpenModal={(isOpen: boolean) => setIsShowModalSettingEdit(isOpen)}
        isOpenModal={isShowModalSettingEdit}
        actionType="update"
        onFetch={() => {
          getLeavePeroid();
        }}
        data={modalData}
      />

      <ContentHeading
        title={"ตั้งค่าวันลา"}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />
      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 md:col-span-3 lg:col-span-3 sm:col-span-12">
          {/* <FilterSelect
            value={inputValueSearch.year ?? ""}
            labelId="year-id"
            placeholder="ปี"
            selectId="year-select-id"
            options={filter_year?.map((year: any, index: number) => (
              <MenuItem value={year?.leave_period} key={index + 1}>
                {year?.leave_period}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("year", e.target.value)
            }
          /> */}
          <StateComponents
            typeProps={[
              {
                seq: 1,
                type: "AUTO-COMPLETE",
                gridProps: {
                  xs: 12
                },
                fieldProps: {
                  options: filter_year,
                  getOptionLabel: (op) => op?.leave_period || "",
                  placeholder: "ปี",
                  labelId: "s",
                  onChange: (_, val) => handleChangeValueSearch("year", val?.leave_period || ""),
                  value: filter_year?.find((x) => x?.leave_period == inputValueSearch?.year) || null
                }
              }
            ]}
          />
        </article>
        <article className="w-full col-span-12 md:col-span-3 lg:col-span-3 sm:col-span-12">
          <StateComponents
            typeProps={[
              {
                seq: 1,
                type: "DATE_RANGE2",
                gridProps: {
                  xs: 12
                },
                fieldProps: {
                  handleChange: (st, end) => {
                    set_start_date(st || "");
                    set_end_date(end || "");
                  },
                  placeholder: "ช่วงวันที่",
                  value: {
                    end_date: end_date,
                    start_date: start_date
                  }
                }
              }
            ]}
          />
        </article>

        <article
          className="w-full col-span-12 md:col-span-6 lg:col-span-6 sm:col-span-12"
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          {checkPermit.isCreated && (
            <ButtonPrimary
              onClick={() => {
                setIsShowModalSetting(true);
              }}
              mode="add"
              buttonName={"เพิ่มรอบปีตั้งค่าวันลา"}
            />
          )}
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1240}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataSettingLeaveDay &&
            dataSettingLeaveDay.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default SettingLeaveDay;
